// extracted by mini-css-extract-plugin
export default {"connected":"GoogleSheetUpload_connected__gbl1x","disconnected":"GoogleSheetUpload_disconnected__cfrJs","feedNameTitle":"GoogleSheetUpload_feedNameTitle__rmFmJ"};